import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

/* function appendGoogleMap() {
  const srcMap = `https://maps.googleapis.com/maps/api/js?key=${
    environment.MAPS_API_KEY}&libraries=places&language=en&callback=googleMapsLoad`;


  (window as any).googleMapsLoad = () => {}

  const script: any = document.createElement('script')
  script.src = srcMap
  document.head.appendChild(script)
} 

appendGoogleMap() */


function getVertical(){
 console.log('Debug-Vertical: ' + window.location.pathname)
}

getVertical()
if (environment.production) {
  enableProdMode()
}

  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
/* document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
}) */
